<template>
	<div class="tt_main tt_reg">
		<div class="tt_box">
			<div class="tt_clo"><span class="tconfont tt-close" @click="handleClose"></span></div>
			<div id="regform">
				<div class="tt_box_t">{{ t('login.zhuce') }}</div>
				<div class="main_form">
					<div class="item" :class="newRegisterFormVo.emailError ? 'error' : ''">
						<div class="tit">
							{{ t('login.zhanghao') }}
							<i>*</i>
						</div>
						<div class="con"><input type="text" v-model="newRegisterFormVo.email" @input="formVerifyError" class="input" :placeholder="t('addPsg.qingshuru') + t('sys.login.email')" /></div>
						<em for="email" class="error" v-if="newRegisterFormVo.emailError && !newRegisterFormVo.email">{{ t('login.cixiangweibitianxiang') }}</em>
						<em for="email" class="error" v-if="newRegisterFormVo.emailError && newRegisterFormVo.email">{{ t('order.geshibuzhengque') }}</em>
					</div>
					<div class="item" :class="newRegisterFormVo.passwordError ? 'error' : ''">
						<div class="tit">
							{{ t('login.mima') }}
							<i>*</i>
						</div>
						<div class="con">
							<input :type="newRegisterRef.passwordType" v-model="newRegisterFormVo.password" class="input" @input="formVerifyError" :placeholder="t('addPsg.qingshuru') + t('login.mima')" />
							<span class="view" :class="newRegisterRef.isPasswordViews ? 'views' : ''" @click="viewsPassword"></span>
						</div>
						<em for="password" class="error" v-if="newRegisterFormVo.passwordError">{{ t('login.cixiangweibitianxiang') }}</em>
					</div>
					<div class="item" :class="newRegisterFormVo.verifyPasswordError ? 'error' : ''">
						<div class="tit">
							{{ t('login.yanzhengmima') }}
							<i>*</i>
						</div>
						<div class="con">
							<input
								:type="newRegisterRef.verifyPasswordType"
								v-model="newRegisterFormVo.verifyPassword"
								@input="formVerifyError"
								class="input"
								:placeholder="t('addPsg.qingshuru') + t('login.yanzhengmima')"
							/>
							<span class="view" :class="newRegisterRef.isVerifyPasswordViews ? 'views' : ''" @click="viewsVerifyPassword"></span>
						</div>
						<em for="verifyPassword" class="error" v-if="newRegisterFormVo.verifyPasswordError">
							{{ newRegisterFormVo.password == newRegisterFormVo.verifyPassword ? t('login.cixiangweibitianxiang') : t('login.mima') + t('login.buyizhi') }}
						</em>
					</div>
				</div>
				<div class="tt_box_btn">
					<a href="javascript:void(0)" class="btn btn2" @click="handleGoLogin">{{ t('login.dengru') }}</a>
					<button type="submit" class="btn btn1" @click="handleGoRegister">{{ t('login.zhuce') }}</button>
				</div>
			</div>
		</div>
		<div class="bg" @click="handleClose"></div>
	</div>
</template>

<script lang="ts" setup>
// import {} from 'vue';
import { HeaderNewRegisterForm, NewHeaderRegisterRef } from '@/logic/header/model/index';
import { memberRegisterLoFun } from '@/logic/header/index';
import { reactive } from 'vue';
import { useMessage } from '@/components/Message/index'; // 自定义封装的message
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const newRegisterFormVo = reactive(new HeaderNewRegisterForm());
const newRegisterRef = reactive(new NewHeaderRegisterRef());
const emits = defineEmits(['closeRegisterPop', 'handleGoLogin']);
function handleClose() {
	emits('closeRegisterPop');
}
function handleGoLogin() {
	handleClose();
	emits('handleGoLogin');
}
async function handleGoRegister() {
	if (formVerifyError()) {
		let res = await memberRegisterLoFun({ email: newRegisterFormVo.email, password: newRegisterFormVo.password });
		if (res.status == 0) {
			useMessage().success(t('login.zhucechenggong'));
			handleClose();
		}
	}
}
function viewsPassword() {
	newRegisterRef.isPasswordViews = !newRegisterRef.isPasswordViews;
	if (newRegisterRef.isPasswordViews) {
		newRegisterRef.passwordType = 'type';
	} else {
		newRegisterRef.passwordType = 'password';
	}
}
function viewsVerifyPassword() {
	newRegisterRef.isVerifyPasswordViews = !newRegisterRef.isVerifyPasswordViews;
	if (newRegisterRef.isVerifyPasswordViews) {
		newRegisterRef.verifyPasswordType = 'type';
	} else {
		newRegisterRef.verifyPasswordType = 'password';
	}
}
//
function formVerifyError() {
	let haveError: boolean = false;
	newRegisterFormVo.emailError = false;
	newRegisterFormVo.passwordError = false;
	newRegisterFormVo.verifyPasswordError = false;
	if (!newRegisterFormVo.email) {
		haveError = true;
		newRegisterFormVo.emailError = true;
	} else {
		let re = /^\w+(?:\.\w+){0,1}@[a-zA-Z0-9]{2,14}(?:\.[a-z]{2,4}){1,2}$/;
		if (!re.test(newRegisterFormVo.email)) {
			haveError = true;
			newRegisterFormVo.emailError = true;
		}
	}
	if (!newRegisterFormVo.password) {
		haveError = true;
		newRegisterFormVo.passwordError = true;
	}
	if (!newRegisterFormVo.verifyPassword) {
		haveError = true;
		newRegisterFormVo.verifyPasswordError = true;
	} else {
		if (newRegisterFormVo.password !== newRegisterFormVo.verifyPassword) {
			haveError = true;
			newRegisterFormVo.verifyPasswordError = true;
		}
	}
	if (!haveError) {
		return true;
	} else {
		return false;
	}
}
</script>

<style lang="scss" scoped>
.tt_main {
	z-index: 999;
}
</style>
